/* istanbul ignore file */

export default {
  "privacy-policy": "https://www.vodafone.ro/privacy",
  "terms-and-conditions":
    "https://www.vodafone.ro/personal/servicii-si-tarife/termeni-si-proceduri-legale/conditiile-de-furnizare-a-serviciilor/index.htm",
  "help-and-support": "https://www.vodafone.ro/asistenta",
  "cookie-preferences": "cookie-preferences",
};
